
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

export const useSessionExpiry = (
  sessionExpireTime: number | null,
  setCurrentUser: (user: null) => void
) => {
  useEffect(() => {
    if (!sessionExpireTime) return;
    
    // Only refresh when we get within 5 minutes of session expiry
    const timeToExpiry = sessionExpireTime * 1000 - Date.now();
    const timeToRefresh = Math.max(0, timeToExpiry - 300000); // 5 minutes before expiry
    
    console.log(`Session expires in ${(timeToExpiry/60000).toFixed(1)} minutes`);
    
    if (timeToExpiry < 0) {
      console.log("Session has already expired");
      setCurrentUser(null);
      toast({
        title: "Session expired",
        description: "Please log in again to continue.",
        variant: "destructive"
      });
      return;
    }
    
    console.log(`Will attempt refresh in ${(timeToRefresh/60000).toFixed(1)} minutes`);
    
    // Set timer to refresh session
    const refreshTimer = setTimeout(async () => {
      console.log("Auto-refreshing session");
      try {
        const { data, error } = await supabase.auth.refreshSession();
        if (error) {
          console.error("Auto-refresh failed:", error);
          toast({
            title: "Session refresh failed",
            description: "Please log in again to continue.",
            variant: "destructive"
          });
        } else if (data.session) {
          console.log("Session refreshed successfully");
          console.log("New expiration:", new Date(data.session.expires_at * 1000).toLocaleString());
        }
      } catch (error) {
        console.error("Unexpected error during auto-refresh:", error);
      }
    }, timeToRefresh);
    
    return () => clearTimeout(refreshTimer);
  }, [sessionExpireTime, setCurrentUser]);
};
